const actions = {
  DONATION_LISTING_ADD_BEGIN: 'DONATION_LISTING_ADD_BEGIN',
  DONATION_LISTING_ADD_SUCCESS: 'DONATION_LISTING_ADD_SUCCESS',
  DONATION_LISTING_ADD_ERR: 'DONATION_LISTING_ADD_ERR',
  
  DONATION_LISTINGS_READ_BEGIN: 'DONATION_LISTINGS_READ_BEGIN',
  DONATION_LISTINGS_READ_SUCCESS: 'DONATION_LISTINGS_READ_SUCCESS',
  DONATION_LISTINGS_READ_ERR: 'DONATION_LISTINGS_READ_ERR',

  DONATION_LISTING_UPDATE_BEGIN: 'DONATION_LISTING_UPDATE_BEGIN',
  DONATION_LISTING_UPDATE_SUCCESS: 'DONATION_LISTING_UPDATE_SUCCESS',
  DONATION_LISTING_UPDATE_ERR: 'DONATION_LISTING_UPDATE_ERR',

  DONATION_LISTING_DELETE_BEGIN: 'DONATION_LISTING_DELETE_BEGIN',
  DONATION_LISTING_DELETE_SUCCESS: 'DONATION_LISTING_DELETE_SUCCESS',
  DONATION_LISTING_DELETE_ERR: 'DONATION_LISTING_DELETE_ERR',

  DONATION_LISTING_READ_BEGIN: 'DONATION_LISTING_READ_BEGIN',
  DONATION_LISTING_READ_SUCCESS: 'DONATION_LISTING_READ_SUCCESS',
  DONATION_LISTING_READ_ERR: 'DONATION_LISTING_READ_ERR',

  DONATION_LISTING_UPLOAD_BEGIN: 'DONATION_LISTING_UPLOAD_BEGIN',
  DONATION_LISTING_UPLOAD_SUCCESS: 'DONATION_LISTING_UPLOAD_SUCCESS',
  DONATION_LISTING_UPLOAD_ERR: 'DONATION_LISTING_UPLOAD_ERR',
  
  CATEGORIES_READ_BEGIN: 'CATEGORIES_READ_BEGIN',
  CATEGORIES_READ_SUCCESS: 'CATEGORIES_READ_SUCCESS',
  CATEGORIES_READ_ERR: 'CATEGORIES_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.DONATION_LISTINGS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.DONATION_LISTINGS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.DONATION_LISTINGS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.DONATION_LISTING_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.DONATION_LISTING_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.DONATION_LISTING_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.DONATION_LISTING_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.DONATION_LISTING_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.DONATION_LISTING_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.DONATION_LISTING_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.DONATION_LISTING_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.DONATION_LISTING_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.DONATION_LISTING_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.DONATION_LISTING_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.DONATION_LISTING_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.DONATION_LISTING_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.DONATION_LISTING_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.DONATION_LISTING_UPLOAD_ERR,
      err,
    };
  },

  axiosCategoriesReadBegin: () => {
    return {
      type: actions.CATEGORIES_READ_BEGIN,
    };
  },

  axiosCategoriesReadSuccess: data => {
    return {
      type: actions.CATEGORIES_READ_SUCCESS,
      data,
    };
  },

  axiosCategoriesReadErr: err => {
    return {
      type: actions.CATEGORIES_READ_ERR,
      err,
    };
  },

};

export default actions;
